export type Item = {
  status: 'ACTIVE' | unknown
  ownerId: string
  id: string
}

export function accountSelector<T extends Item>(accounts: T[] = [], id?: string) {
  return accounts.filter(item => item.status === 'ACTIVE').find(item => item.ownerId === id)
}
